import api from './api';

export interface SosContact {
  _id?: string | { $oid?: string };
  id?: string;
  name: string;
  phone: string;
  relation?: string;
  createdAt?: string;
}

export interface CreateSosContactPayload {
  name: string;
  phone: string;
  relation?: string;
}

export const sosService = {
  listContacts: async (): Promise<SosContact[]> => {
    const response = await api.get('/sos/contacts');
    return Array.isArray(response.data) ? response.data : [];
  },

  createContact: async (payload: CreateSosContactPayload): Promise<SosContact> => {
    const response = await api.post('/sos/contacts', payload);
    return response.data;
  },

  deleteContact: async (contactId: string): Promise<void> => {
    await api.delete(`/sos/contacts/${contactId}`);
  },
};
